import { EuroValue, IFibuAccountConfigItem } from '@dokucoach/common-types';
import * as yup from 'yup';

export type ITrainingLevy = {
  label: string;
  amount: number;
  fibuAccountStationaryConfigItem: IFibuAccountConfigItem;
  fibuAccountNonStationaryConfigItem: IFibuAccountConfigItem;
};

export type ITrainingLevyCreate = {
  label: string;
  amount: number;
  fibuAccountStationaryConfigItem: IFibuAccountConfigItem;
  fibuAccountNonStationaryConfigItem: IFibuAccountConfigItem;
};

export const ITrainingLevyCreateSchema = yup.object({
  label: yup.string().required(),
  amount: EuroValue.required(),
  fibuAccountStationaryConfigItem: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  fibuAccountNonStationaryConfigItem: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
});
